/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/**
 * This method supports our application with all supported languages messages in the form of
 * locales = {
 *     [Key is the locale itself]: Object that containing the messages.
 * }
 */
export const getLocale = async (localeCode: string) => {
    switch (localeCode) {
        case 'en':
            return import(/* webpackChunkName: "en-strings" */ 'src/assets/i18n/en/strings.json');
        case 'de':
            return import(/* webpackChunkName: "de-strings" */ 'src/assets/i18n/de/strings.json');
        case 'nl':
            return import(/* webpackChunkName: "nl-strings" */ 'src/assets/i18n/nl/strings.json');
        case 'es':
            return import(/* webpackChunkName: "es-strings" */ 'src/assets/i18n/es/strings.json');
        case 'fr':
            return import(/* webpackChunkName: "fr-strings" */ 'src/assets/i18n/fr/strings.json');
        case 'it':
            return import(/* webpackChunkName: "it-strings" */ 'src/assets/i18n/it/strings.json');
        case 'ja':
            return import(/* webpackChunkName: "ja-strings" */ 'src/assets/i18n/ja/strings.json');
        case 'zh-Hans':
            return import(/* webpackChunkName: "zh-strings" */ 'src/assets/i18n/zh-Hans/strings.json');
        default:
    }
};
